import { simplePath } from "../utils.js";
const GET_IS_UNIQUE_ORG_NAME_PATH = '/v2/organization/is-unique-name/:name';
function get_organization_by_name_path(params) {
    return simplePath(GET_IS_UNIQUE_ORG_NAME_PATH, params);
}
export { GET_IS_UNIQUE_ORG_NAME_PATH, get_organization_by_name_path };
